import { createStyles } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    profileButton: {
        marginTop: theme.spacing.md,
    },
    profileIcon: {
        border: `4px solid ${theme.colors.gray[2]}`,
        cursor: "pointer",

        ".svg-inline--fa": {
            width: "70%",
            height: "70%",
        },

        ".mantine-Avatar-placeholder": {
            backgroundColor: theme.colors.gray[1],
        },
    },
    profileLabel: {
        color: theme.colors.gray[7],
        fontSize: theme.fontSizes.sm,
        fontWeight: 500,
        lineHeight: "1.06rem",
    },
    switch: {
        ".mantine-Switch-body": {
            justifyContent: "space-between",

            [theme.fn.largerThan("xs")]: {
                justifyContent: "flex-start",
            },
        },

        ".mantine-Switch-labelWrapper": {
            order: 0,

            [theme.fn.largerThan("xs")]: {
                order: 1,
            },
            marginBottom: 0,
        },

        ".mantine-Switch-label": {
            [theme.fn.smallerThan("xs")]: {
                paddingLeft: 0,
            },
            marginBottom: 0,
        },
    },
    switchLabel: {
        fontWeight: 400,
    },
    uploadIcon: {
        backgroundColor: theme.white,
        boxShadow: "0px 4px 8px -2px rgba(0, 0, 0, 0.12)",
        marginBottom: "4px",
        marginLeft: "-36px",
    },
    labelAsterisk: {
        "&:is(span)": {
            paddingLeft: "4px",
            color: `${theme.colors.red[8]} !important`,
        },
    },
    labelContainer: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-start",
    },
    stylizedIcon: {
        height: "6rem",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    segmentButtonWrapper: {
        "&:not(:first-of-type)": {
            borderWidth: 0,
        },
    },
    segmentButtonLabel: {
        "&[data-active]": {
            color: theme.colors.primary[9],
            "&:hover": {
                color: theme.colors.primary[9],
            },
        },
    },
}))
